import React, { useEffect, useRef, useState } from 'react';
import Header from '../../../components/header';
import Layout from '../../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../../components/icons';
import Drawer from '../../../components/Drawer';
import Button from '../../../components/elements/button';
import { PAGE_SIZE } from '../../../_common/constant';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import Loader from '../../../components/loader';
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { titleCell } from '../../../components/elements/function';

import toast from 'react-hot-toast';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import CreateMasterDepartment from './CreateMasterDepartment';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';


const MasterDepartment: React.FC = () => {
    const createDrawerRef: any = useRef();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [rowData, setRowData] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);
    const assetApi: any = useAssetsApi();

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('departmentFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('departmentFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const addNewDepartmentRef: any = React.createRef<HTMLButtonElement>();
    const createDepartmentRef: any = useRef();

    const filterConfig: filterConfigType[] = [
        { name: 'Department Name', type: 'text', key: 'departmentName' },
    ];

    const { confirm } = useDialog();
    const commonApi: any = useCommonApi();

    const onGridReady = (params: any) => {
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    const columnDefs = [
        { headerName: 'Department Name', field: 'departmentName', headerClass: 'bg-[#f0f0f0]', width: 450 },
        { headerName: 'Bill.com Department Name', field: 'billComDepartmentName', headerClass: 'bg-[#f0f0f0]', minWidth: 350, flex: 1 },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,
            pinned: 'right',
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                let action = e.target.value;
                                handleActionChange(e, params);
                                //e.target.value = '';
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit">Edit</option>
                            {/* <option value="delete">Delete</option> */}

                        </select>
                    </div>
                );
            },

        }
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                setEditData(rowData);
                addNewDepartmentRef.current.open();
                console.log("Edit action for department: ", rowData);
                break;
            /* case "delete":
                confirm({
                    type: 'delete',
                    title: 'Delete Department',
                    message: `Are you sure you want to delete the department "${rowData.name}"?`,
                    onConfirm: () => {
                        commonApi.DeleteTeam(
                            { teamID: rowData.teamID },
                            (resp: any) => {
                                toast.success('Department deleted successfully');
                                getDepartmentList();
                            },
                            (error: any) => {
                                console.log("Error deleting department:", error);
                                toast.error(error?.message || "Failed to delete department");
                            }
                        );
                    }
                });
                break;
             */default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const getDepartmentList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }

        setRowData(null);

        assetApi.getAssetdepartment(
            payload,
            (resp: any) => {
                if (resp && resp.departmentsList && Array.isArray(resp.departmentsList)) {
                    setRowData(resp.departmentsList);
                    setTotalRecords(resp.totalRecord || resp.departmentsList.length);
                } else {
                    setRowData([]);
                    setTotalRecords(0);
                }
            },
            (error: any) => {
                console.log("Error fetching Department list:", error);
                toast.error(error || "Failed to fetch Department list");
                setRowData([]);
                setTotalRecords(0);
            }
        );
    };

    // Call getDepartmentList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            getDepartmentList();
        }

        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters, filtersInitialized]);

    return (
        <Layout>
            <Header title="Master Department List" back="/settings" >
                <Header.Right>
                    <Drawer _ref={addNewDepartmentRef} onClose={() => {
                        setEditData(null);
                        createDepartmentRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>{editData ? 'Edit' : 'Create'} Department</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Department' : 'Create New Department'} className='!w-[39.563rem]'>
                            <CreateMasterDepartment _ref={createDepartmentRef} editData={editData} onCreate={() => {
                                setEditData(null);
                                getDepartmentList();
                                addNewDepartmentRef?.current?.close();
                            }} onCancel={() => {
                                setEditData(null);
                                addNewDepartmentRef?.current?.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                {/* <Search onSearch={setSearchParam} placeholder='Search by department name or ID'/> */}
            </div>
            <div className='bg-[#FAFAFA] w-full'>
                {/* <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        localStorage.removeItem('departmentFilters');
                        setFiltersApplied({ generalFilter: false });
                        setCurrentPage(1);
                    }} >Clear Filters</p>
                </div> */}
                <div className="ag-theme-alpine px-4 w-full h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData || []}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        pagination={false}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default MasterDepartment;